import React from "react";
import { Link as RouterLink } from "react-router-dom";
import { Box, Container, Heading, Text, Stack, Button } from "@chakra-ui/react";
import { Building2, Plane } from "lucide-react";
import { useLocalPath, useText } from "../../i18n/lang";

const TEXT = {
  en: {
    title: "Let's talk about your travel",
    text: "Tell us what your company or agency needs and our team will get back to you with a tailored proposal.",
    companies: "Contact us for your company",
    agencies: "Request a Booking Time demo",
  },
  ro: {
    title: "Hai să discutăm despre călătoriile tale",
    text: "Spune-ne de ce are nevoie compania sau agenția ta, iar echipa noastră revine cu o propunere adaptată.",
    companies: "Contactează-ne pentru compania ta",
    agencies: "Solicită un cont demo Booking Time",
  },
};

const HomeCta = () => {
  const t = useText(TEXT);
  const localPath = useLocalPath();

  return (
    <Box py={{ base: 14, md: 20 }} bgGradient="linear(135deg, #0b1f3a 0%, #123a6b 55%, #1d5fa8 100%)" color="white">
      <Container maxW="container.lg" textAlign="center">
        <Heading as="h2" fontFamily="Montserrat" fontWeight="700" fontSize={{ base: "2xl", md: "4xl" }} mb={4}>
          {t.title}
        </Heading>
        <Text fontSize={{ base: "md", md: "lg" }} color="blue.50" maxW="2xl" mx="auto" mb={8} lineHeight="1.7">
          {t.text}
        </Text>
        <Stack direction={{ base: "column", md: "row" }} spacing={4} justify="center">
          <Button
            as={RouterLink}
            to={localPath("/contact")}
            onClick={() => window.scrollTo(0, 0)}
            size="lg"
            h="56px"
            px={8}
            colorScheme="orange"
            bg="orange.600"
            _hover={{ bg: "orange.700" }}
            leftIcon={<Building2 size={20} />}
          >
            {t.companies}
          </Button>
          <Button
            as={RouterLink}
            to={`${localPath("/agentii-partenere")}#cont-demo`}
            size="lg"
            h="56px"
            px={8}
            variant="outline"
            color="white"
            borderColor="whiteAlpha.700"
            _hover={{ bg: "whiteAlpha.200" }}
            leftIcon={<Plane size={20} />}
          >
            {t.agencies}
          </Button>
        </Stack>
      </Container>
    </Box>
  );
};

export default HomeCta;
